import React, { useState } from 'react';
import styles from './style.module.scss';
import { Upload } from 'antd';
import MenuService from '../../services/MenuService';

const AddCard = (props) => {
    const { setNewCard, newCard } = props;
    const onSectionChange = (e) => {
        const cardData = {...newCard};
        cardData[e.target.name] = e.target.value;
        setNewCard(cardData);
    };
    const uploadImage = async(options) =>{
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        formData.append('file', file);
        const urlResponse = await MenuService.uploadMenuItemPhoto(formData);  
        const newItemList = { ...newCard }
        newItemList.photo_url = urlResponse.url;
        setNewCard(newItemList);
        onSuccess(true);
    };
    return <div className={styles.add_sec}>
        <div className={styles.upload_btn}>
             <Upload fileList={[]} customRequest={uploadImage}>
             {newCard.photo_url ?
                <div className={styles.menu_uploads}>
                     <img
                     src={newCard.photo_url}
                     alt="avatar"
                     style={{
                         width: '100%',
                         height: 'inherit'
                     }}
                     /> 
                 </div> 
                 :
                 <div className={styles.menu_uploads}>
                    <div>
                        <img src="/images/upload.png" alt="FoodLuv" />
                        <p>Upload image</p>
                    </div>
                </div>}
            </Upload>
        </div>
        <div><input className={styles.addsec_label} value={newCard.name} name="name" placeholder='Enter Section name here' onChange={(e)=>{onSectionChange(e)}}/></div>
    </div>
};
export default AddCard;